var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-jaleklinico-imagem","dialog-class":"modal-imagem","hide-header":"","hide-footer":"","size":"xl","no-enforce-focus":true}},[_c('img',{attrs:{"src":_vm.obterUrlS3(_vm.imagem),"width":"150px"}}),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }